import React from 'react';
import PartnerClubsPage from '../../../pages/PartnerClubsPage';

export default function HelpPartnerClubsPanel() {
  return <PartnerClubsPage embedded />;
}
